module.exports = __webpack_public_path__ + "static/media/errorcard.2af57bd4.svg";